import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductSwitchOfferQuery } from "src/api/productSwitchOffers";
import { BillingCyclePreviewProto } from "@noom/noom-contracts/noom_contracts/billing/bms/subscriptions/billing_cycle_preview";
import { BillingIntervalProto } from "@noom/noom-contracts/noom_contracts/billing/billing_interval";
import { MoneyProto } from "@noom/noom-contracts/noom_contracts/lib/money";

export type ProductSwitchPreviewOrder = {
  loading?: boolean;
  error?: boolean;
  initialBillingCycle?: BillingCyclePreviewProto;
  recurringBillingCycle?: BillingCyclePreviewProto;
  refundAmount?: MoneyProto;
};

export type ProductSwitchState = {
  loaded: boolean;
  currentProductName: string | null;
  currentPlanPrice: number | null;
  currentBillingInterval: BillingIntervalProto | null;
  offers: ProductSwitchOfferQuery[];
  selectedOffer: ProductSwitchOfferQuery | null;
  isDeferredSwitch: boolean;
  switchStartDate: string | null;
  previewOrders: Record<string, ProductSwitchPreviewOrder>;
};

const initialState: ProductSwitchState = {
  loaded: false,
  currentProductName: null,
  currentPlanPrice: null,
  currentBillingInterval: null,
  offers: [],
  selectedOffer: null,
  isDeferredSwitch: false,
  switchStartDate: null,
  previewOrders: {},
};

const productSwitchSlice = createSlice({
  name: "productSwitch",
  initialState,
  reducers: {
    setProductSwitchData(
      state,
      action: PayloadAction<Partial<ProductSwitchState>>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setPreviewOrder(
      state,
      action: PayloadAction<{
        productName: string;
        previewOrder: ProductSwitchPreviewOrder;
      }>
    ) {
      return {
        ...state,
        previewOrders: {
          ...state.previewOrders,
          [action.payload.productName]: action.payload.previewOrder,
        },
      };
    },
    clearProductSwitchData() {
      return initialState;
    },
  },
});

export const { setProductSwitchData, setPreviewOrder, clearProductSwitchData } =
  productSwitchSlice.actions;

export default productSwitchSlice;
